import { IBucketDistribution, IPageExperiment, IPageLevelExperimentConfig } from './pageExperiments.types'

export const getBucketToAssign = (
  experiment: IPageLevelExperimentConfig,
  hashBucket: number,
): IBucketDistribution | undefined => {
  let curBucketStart = 0
  for (const bucket of experiment.bucketsDistribution) {
    if (curBucketStart + bucket.ratio > hashBucket) {
      return bucket
    }
    curBucketStart += bucket.ratio
  }

  return experiment.bucketsDistribution[experiment.bucketsDistribution.length - 1]
}

const findSlugIndex = (experimentConfig: IPageLevelExperimentConfig, slug: string) => {
  const slugsForBuckets = experimentConfig.bucketToSlugs
  let slugIndex = -1

  Object.keys(slugsForBuckets).forEach(bucketName => {
    const slugs = slugsForBuckets[bucketName]

    if (slugs?.length) {
      const index = slugs.indexOf(slug)
      if (index > -1) {
        slugIndex = index
      }
    }
  })

  return slugIndex
}

export const isValidBucketValue = (bucket: string, experimentConfig: IPageExperiment) => {
  const bucketNames = Object.values(experimentConfig.buckets)
  const isValidBucket = bucketNames.includes(bucket)

  return isValidBucket
}

export const getSlugForBucket = (
  experimentConfig: IPageLevelExperimentConfig,
  assignedBucket: string,
  requestedSlug: string,
) => {
  if (!isValidBucketValue(assignedBucket, experimentConfig) || !experimentConfig.pages.includes(requestedSlug)) {
    return requestedSlug
  }

  const slugIndex = findSlugIndex(experimentConfig, requestedSlug)
  if (slugIndex < 0) {
    return requestedSlug
  }

  return experimentConfig.bucketToSlugs[assignedBucket]?.[slugIndex]
}
